import React, { useEffect, useRef } from "react";
import { bool, func, instanceOf, number } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import Selector from "pages/_components/fields/formik/Selector";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import { actions as ThirdPartiesActions } from "reducers/thirdPayment";
import { states } from "util/thirdPayment";
import { getLimitDate } from "util/date";
import * as i18n from "util/i18n";

const FORM_ID = "payThirdParties";

const FilterForm = ({ customValues, closeSidebar, isEmittedForm, positionTab }) => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { filterThirdParties } = useSelector((state) => state.thirdPayment);
    const statesOptions = i18n.formatOptionNoSpace(states, "payThirdParties.states");
    const initialValues = {
        status: "TODOS",
        amountFrom: "",
        amountTo: "",
        ...customValues,
    };

    useEffect(() => {
        const requestFilters = {
            status: initialValues.status,
            dateFrom: initialValues?.dateRange[0],
            dateTo: initialValues?.dateRange[1],
            amountFrom: initialValues.amountFrom,
            amountTo: initialValues.amountTo,
            ...filterThirdParties,
        };
        dispatch(ThirdPartiesActions.setThirdPartiesFilters({ ...requestFilters, pageNumber: 1 }));
    }, []);

    useEffect(() => {
        if (!formRef.current) {
            return;
        }

        const filtersTags = Object.entries(filterThirdParties);
        filtersTags.forEach((item) => {
            if (item[0] === "dateFrom") {
                formRef.current.setFieldValue("dateRange[0]", item[1]);
            }
            if (item[0] === "dateTo") {
                formRef.current.setFieldValue("dateRange[1]", item[1]);
            }
            formRef.current.setFieldValue(item[0], item[1]);
        });
    }, [filterThirdParties]);

    const handleSubmit = (values) => {
        const requestFilters = {
            ...filterThirdParties,
            status: values.status,
            dateFrom: values.dateRange[0],
            dateTo: values.dateRange[1],
            amountFrom: values.amountFrom,
            amountTo: values.amountTo,
            typePayment: positionTab === 0 ? "PP" : "PH",
        };
        dispatch(ThirdPartiesActions.setThirdPartiesFilters(requestFilters));
        dispatch(ThirdPartiesActions.loadListThirdRequest(requestFilters));

        closeSidebar((state) => !state);
    };
    const handleReset = (setFieldValue) => {
        setFieldValue("status", "TODOS");
        setFieldValue("dateRange", [null, null]);
        setFieldValue("amountFrom", "");
        setFieldValue("amountTo", "");
    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} ref={formRef}>
            {({ setFieldValue }) => (
                <Form>
                    <Row>
                        <>
                            <Col xs={12} md={6}>
                                <Field
                                    idForm={FORM_ID}
                                    name="status"
                                    component={Selector}
                                    options={statesOptions}
                                    placeholder={i18n.get("parties.placeholder.todos")}
                                />
                            </Col>
                            <Col xs={12} md={6}>
                                <Field
                                    component={DateRangeField}
                                    hidePlaceholder
                                    idForm={FORM_ID}
                                    minDate={getLimitDate(-184)}
                                    maxDate={getLimitDate(99999)}
                                    name="dateRange"
                                    dateFormat="dd/MM/yyyy"
                                    selectsRange
                                    showMonthYearDropdown
                                    scrollableMonthYearDropdown
                                />
                            </Col>
                            <Col xs={12} md={6}>
                                <Field
                                    component={TextField}
                                    hidePlaceholder
                                    idForm={FORM_ID}
                                    name="amountFrom"
                                    type="text"
                                    pattern="[0.0-9.9]*"
                                    maxLength={11}
                                    minLength={0}
                                />
                            </Col>
                            {isEmittedForm && (
                                <Col xs={12} md={6}>
                                    <Field
                                        component={TextField}
                                        hidePlaceholder
                                        idForm={FORM_ID}
                                        name="amountTo"
                                        type="text"
                                        pattern="[0.0-9.9]*"
                                        maxLength={11}
                                        minLength={0}
                                    />
                                </Col>
                            )}
                        </>
                    </Row>
                    <Row className="form-actions">
                        <Col xs={12} md={6}>
                            <Button
                                className="btn-outline"
                                label="echecks.clean.filters"
                                onClick={() => handleReset(setFieldValue)}
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <Button type="submit" className="btn-primary" label="echecks.filtering" />
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
};

FilterForm.propTypes = {
    customValues: instanceOf(Object).isRequired,
    closeSidebar: func.isRequired,
    isEmittedForm: bool,
    positionTab: number.isRequired,
};

FilterForm.defaultProps = {
    isEmittedForm: false,
};

export default FilterForm;
